import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';
import { Employee } from '@quorum/models/xs-resource';
import { svcDropdownsFeatureSelector } from '../svc-dropdowns-feature.selector';
export interface EmployeesState extends EntityState<Employee> {}

export const employeesAdapter: EntityAdapter<Employee> = createEntityAdapter<Employee>({
  selectId: (employee: Employee) => employee.associateId,
});

export const initialState: EmployeesState = employeesAdapter.getInitialState();
export const employeesSelector = createSelector(svcDropdownsFeatureSelector, (state: any) => {
  return state.employees;
});

export const { selectIds, selectEntities, selectAll, selectTotal } = employeesAdapter.getSelectors(employeesSelector);
